module.exports = __webpack_public_path__ + "img/ep-logo (2).10b1da5a.svg";